import api from "./axios";

export const listValues = async (search = "", type = "", screen) => {
  try {
    const params = { search, type };
    if (screen) params.screen = screen;
    const response = await api.get("/common/list-values", { params });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch list values");
  }
};

export const countriescode = async (search_key = "") => {
  try {
    const response = await api.get("/common/countries-code", {
      params: { search_key },
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch country code");
  }
};

export const religions = async (search = "", parent_id = 1) => {
  try {
    const response = await api.get("/common/religions", {
      params: { search, parent_id },
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch religions");
  }
};

export const communities = async (search = "", parent_id = 1, screen) => {
  try {
    const params = { search, parent_id };
    if (screen) params.screen = screen;
    const response = await api.get("/common/communities", {
      params,
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch communities");
  }
};

export const nationality = async (search = "") => {
  try {
    const response = await api.get("/common/countries", {
      params: { search },
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch countries");
  }
};

export const states = async (search = "", country_id) => {
  try {
    const response = await api.get("/common/states", {
      params: {
        search,
        country_id: Array.isArray(country_id)
          ? JSON.stringify(country_id)
          : country_id,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch countries");
  }
};

export const districts = async (search = "", parent_id) => {
  try {
    const response = await api.get("/common/cities", {
      params: {
        search,
        parent_id: Array.isArray(parent_id)
          ? JSON.stringify(parent_id)
          : parent_id,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch countries");
  }
};

export const towns = async (search = "", place_id) => {
  try {
    const response = await api.get("/common/towns", {
      params: {
        search,
        place_id: Array.isArray(place_id) ? JSON.stringify(place_id) : place_id,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch countries");
  }
};

export const interests = async () => {
  try {
    const response = await api.get("/common/interests/");
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch countries");
  }
};

export const personalities = async () => {
  try {
    const response = await api.get("/common/personalities/");
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch countries");
  }
};

export const qualification = async (search = "", parent_id, screen) => {
  try {
    const params = { search, parent_id };
    if (screen) params.screen = screen;
    const response = await api.get("/common/qualifications", { params });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch qualifications");
  }
};

export const courses = async (search = "", parent_id = "") => {
  if (!parent_id || (Array.isArray(parent_id) && parent_id.length === 0)) {
    return [];
  }
  try {
    const response = await api.get("/common/courses", {
      params: {
        search,
        parent_id: Array.isArray(parent_id)
          ? JSON.stringify(parent_id)
          : parent_id,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch courses");
  }
};

export const profession = async (search = "", screen) => {
  try {
    const params = { search };
    if (screen) params.screen = screen;
    const response = await api.get("/common/occupations", {
      params,
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch countries");
  }
};

export const incomes = async (search = "", screen) => {
  try {
    const params = { search };
    if (screen) params.screen = screen;
    const response = await api.get("/common/incomes", { params });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch incomes");
  }
};

export const UserCommunities = async (search = "") => {
  try {
    const response = await api.get("/users/community-list/", {
      params: { search },
    });
    return response.data.data;
  } catch (error) {
    console.error("API error:", error);
    throw new Error("Failed to fetch countries");
  }
};
